enum PlatformType {
  PROGRESSMONITOR = 'PROGRESSMONITOR',
  CHALLENGEMONITOR = 'CHALLENGEMONITOR',
}

export default PlatformType;
